export default (modules, users) => {
  if (users.type.SELLER) {
    if (modules['Products']) {
      modules['Programs'].subtabs = {
        'Products': {
          label: '#Products',
          subtabs: modules['Products'].subtabs
        },
        ...modules['Programs'].subtabs
      }
    }

    modules['Programs'].alias = 'Actions'

    if (modules['Programs'].subtabs) {
      if (modules['Programs'].subtabs['RFPs']) {
        modules['Programs'].entry = '/i/Programs/RFP-received/'
      } else if (modules['Programs'].subtabs['POs']) {
        modules['Programs'].entry = '/i/Programs/PO-received/'
      } else if (modules['Programs'].subtabs['Products']) {
        modules['Programs'].entry = '/d/Programs/Products/MyProduct'
      }
    }

    delete modules['Programs'].subtabs['Invoices']
    delete modules['Products']

    modules['Dashboard'].title = 'Summary of payments and recent activity'
    modules['Dashboard'].subtitle = users.user.CompanyName
  }

  return modules
}



// WEBPACK FOOTER //
// ./src/core/legacy-auth/suppliers.js